<template>
  <div>
  <ApplicationBrandBar />
    <!-- Modal -->
    <div v-if="badbrowser" class="modal modal-message modal-warning fade" id="exampleModalLong"
	tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content ">
          <div class="modal-header">
            <i class="fa fa-warning"></i><h5 class="modal-title" id="exampleModalLongTitle">{{user_lang.ieNotSupported}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-title">{{user_lang.attention}}</div>
          <div class="modal-body">
           {{user_lang.tryChrome}}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{user_lang.close}}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Closed Modal -->
    <slot></slot>
    <ApplicationFooter />
    <SessionTimeout />
  </div>
</template>
<script>
import ApplicationFooter from "@/components/footer/footer.vue";
import ApplicationBrandBar from "@/components/header/brandBar/brandBar.vue";
import bowser from 'bowser';
import SessionTimeout from "@/components/widgets/SessionTimeout.vue";
import { EventBus } from '@/event-bus.js';
import { locale } from '@/i18n/locale.js'
export default {
  name: 'TopNavFooter',
  data() {
    return {
      lang: locale.lang,
      lang_obj: locale.lang_obj,
      badbrowser: false,
      user_lang: {}
    }
  },
  created() {
     // check user language and assign corresponding label object
    var self = this
    setTimeout(self.assignUserLang(), 1000) // lang_br for br portuguese
    EventBus.$on('lang', function (language) {
      self.user_lang = self.lang_obj[language]
    })
    if (bowser.msie) {
      // this.badbrowser = true
    }
    $(window).load(function() {
      $('#exampleModalLong').modal('show');
    });
  },
  components: {
    ApplicationFooter,
    ApplicationBrandBar,
    SessionTimeout
  },
  methods: {
    assignUserLang() {
      var self = this
      self.user_lang = self.lang_obj[this.lang]
    }
  }
}
</script>
<style scope>
body {
   /* padding-top:64px; */
}
.modal-content {
    -webkit-border-radius: 0;
    -webkit-background-clip: padding-box;
    -moz-border-radius: 0;
    -moz-background-clip: padding;
    border-radius: 6px;
    background-clip: padding-box;
    -webkit-box-shadow: 0 0 40px rgba(0,0,0,.5);
    -moz-box-shadow: 0 0 40px rgba(0,0,0,.5);
    box-shadow: 0 0 40px rgba(0,0,0,.5);
    color: #000;
    background-color: #fff;
    border: rgba(0,0,0,0);
}
.modal-message .modal-body, .modal-message .modal-footer, .modal-message .modal-header, .modal-message .modal-title {
    background: 0 0;
    border: none;
    margin: 0;
    padding: 0 20px;
    text-align: center!important;
}
.modal-message .modal-title {
    font-size: 1.5rem;
    color: #737373;
    margin-bottom: 3px;
}
.modal-message .modal-body {
    color: #737373;
    padding-top: 20px;
}
.modal-message .modal-header {
    color: #fff;
    margin-bottom: 10px;
    padding: 15px;
}
.modal-message .modal-header .fa,
.modal-message .modal-header
.glyphicon, .modal-message
.modal-header .typcn, .modal-message .modal-header .wi {
    font-size: 3rem;
}
.modal-message .modal-footer {
    margin: 25px 0 20px;
    padding-bottom: 10px;
}
.modal-message.modal-warning .modal-header {
    color: #f4b400;
    border-bottom: 3px solid #ffce55;
}
</style>



// WEBPACK FOOTER //
// TopNavFooter.vue?62dd9a5c